<template>
  <div class="">
    <!-- Question mark icon -->
    <div
      ref="iconRef"
      class="w-4 h-4 bg-gray-400 hover:bg-gray-500 rounded-full flex items-center justify-center cursor-help transition-colors duration-200"
      @mouseenter="scheduleOpen"
      @mouseleave="scheduleClose"
    >
      <span class="text-white text-xs font-bold">i</span>
    </div>

    <!-- Tooltip using Teleport -->
    <Teleport to="body">
      <div
        v-if="isOpen"
        ref="tooltipRef"
        class="z-[9999] fixed w-64 p-3 bg-gray-800 text-white rounded-lg shadow-lg"
        :style="style"
        @mouseenter="cancelClose"
        @mouseleave="scheduleClose"
      >
        <!-- Arrow, aligned to the icon and flipped with the placement -->
        <div
          class="absolute w-0 h-0 border-l-4 border-r-4 border-transparent -translate-x-1/2"
          :class="placement === 'above' ? 'top-full border-t-4 border-t-gray-800' : 'bottom-full border-b-4 border-b-gray-800'"
          :style="{ left: `${arrowOffset}px` }"
        />

        <!-- Content -->
        <div class="text-sm">
          <h4 v-if="title" class="font-semibold mb-1">{{ title }}</h4>
          <p v-if="description" class="text-gray-300 leading-relaxed">{{ description }}</p>
          <div v-if="$slots.extra" class="mt-2 pt-2 border-t border-gray-700">
            <slot name="extra" />
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import { useAnchoredPopover, activePopoverId } from '../../composables/useAnchoredPopover.js';

let uid = 0;

export default {
  name: 'Info',
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  setup() {
    const iconRef = ref(null);
    const tooltipRef = ref(null);
    const id = `info-popover-${++uid}`;

    // Default 120 ms delays so the pointer can travel into the popover.
    const {
      isOpen, style, placement, arrowOffset, close, scheduleOpen, scheduleClose, cancelClose,
    } = useAnchoredPopover(
      iconRef,
      tooltipRef,
    );

    // Participate in the app-wide one-popover-at-a-time contract.
    watch(isOpen, (open) => {
      if (open) activePopoverId.value = id;
      else if (activePopoverId.value === id) activePopoverId.value = null;
    });
    watch(activePopoverId, (current) => {
      if (current !== id && isOpen.value) close();
    });

    return {
      iconRef,
      tooltipRef,
      isOpen,
      style,
      placement,
      arrowOffset,
      scheduleOpen,
      scheduleClose,
      cancelClose,
    };
  },
};
</script>
